import React, { Fragment, useState, useEffect } from 'react'
import ResponseReview from './ResponseReview'

import StarPicker from 'react-star-picker';


const Review = (props) => {


    const getResponses = ()=>{
        if(props.response.length > 0){
                return(
                    <ResponseReview response={props.response}></ResponseReview>
                )
        }else{
            return( 
                <p style={{color:'#A9A9A9'}}>No responses yet</p>
            )
        }
    }


    useEffect(() => {
     getResponses()
    })

    return (


        
        <article className='review'>

            <div className='writerName'>
                <h6>{props.author}</h6>
                <div className='dateUbicacion'>
                    {props.location} {props.dateComment}
                </div>
            </div>

            <StarPicker  value={props.rating} />

            <div className='dateUbicacion'>
                <textarea disabled cols='30' rows='20' style={{fontSize:'15px'}} className='textReview'>
                    {props.text}
                </textarea>
            </div>

            {getResponses()}
                    
            

          

        </article>
    )

}


export default Review